import { render } from "./CommandSetup.vue?vue&type=template&id=5e6bcb5b&scoped=true"
import script from "./CommandSetup.vue?vue&type=script&lang=js"
export * from "./CommandSetup.vue?vue&type=script&lang=js"

import "./CommandSetup.vue?vue&type=style&index=0&id=5e6bcb5b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e6bcb5b"

export default script